<template>
	<div id="editor">
		<div
			v-if="working"
			class="d-flex justify-content-center align-items-center"
			style="min-height:300px"
		>
			<spinner size="huge" message="Loading..."></spinner>
		</div>
		<div v-if="!working">
			<div class="container">
				<b-row class="head">
					<b-col sm="9">
						<h3>
							Ticket #<i>{{ ticket.TI_ID }}</i>
						</h3>
					</b-col>
					<b-col sm="3">
						<b-form>
							<b-form-select
								size="sm"
								v-model="ticket.TI_STATUS"
								:options="statusse"
								@change="changeStatus($event, ticket.TI_ID)"
							></b-form-select>
						</b-form>
					</b-col>
				</b-row>

				<b-row>
					<b-col sm="4" lg="2" class="fett text-right">Date</b-col>
					<b-col sm="8" lg="4">{{ ticket.TI_CD }}</b-col>
					<b-col sm="4" lg="2" class="fett text-right">From</b-col>
					<b-col sm="8" lg="4">{{ ticket.TI_FROMMAIL }}</b-col>
				</b-row>

				<b-row>
					<b-col sm="4" lg="2" class="fett text-right">Domain</b-col>
					<b-col sm="8" lg="4">{{ ticket.TI_DOMAIN }}</b-col>
					<b-col sm="4" lg="2" class="fett text-right">Type</b-col>
					<b-col sm="8" lg="4">{{ ticket.TI_SITETYPE }}</b-col>
				</b-row>

				<b-row>
					<b-col sm="4" lg="2" class="fett text-right">Url</b-col>
					<b-col sm="8" lg="10"
						><a :href="ticket.messages[0].MSG_URL" target="_blank">{{
							ticket.messages[0].MSG_URL
						}}</a></b-col
					>
				</b-row>
				<b-row>
					<b-col sm="4" lg="2" class="fett text-right">Server Error</b-col>
					<b-col sm="8" lg="10" class="msg">{{
						ticket.messages[0].MSG_ERRORMESSAGE
					}}</b-col>
				</b-row>
				<b-row>
					<b-col sm="4" lg="2" class="fett text-right">Message</b-col>
					<b-col sm="8" lg="10" class="msg">{{
						ticket.messages[0].MSG_TEXT
					}}</b-col>
				</b-row>

				<b-row v-if="ticket.messages[0].MSG_ATTACHMENTS">
					<b-col sm="4" lg="2" class="fett text-right">Screenshots</b-col>
					<b-col sm="8" lg="10">
						<div v-for="(item, idx) in ticket.messages[0].MSG_ATTACHMENTS">
							<img :src="item.medium" @click.stop="showBig(idx)" />{{ idx}}
						</div>
					</b-col>
				</b-row>
				<div v-if="ticket.messages[1]">
					<h3>Answers</h3>
					<b-row v-for="(msg, idx) in ticket.messages" v-if="idx > 0">
						<b-col sm="4" lg="2" class="fett text-right">
							{{msg.MSG_FROMMAIL}}
							<br/>
							{{msg.MSG_CD}}
						</b-col>
						<b-col sm="8" lg="10" class="msg">
							{{msg.MSG_TEXT}}
						</b-col>
					</b-row>
				</div>
			</div>
		</div>
		<AttachmentDetail :imgurl="imgurl" />
		<h2>Answer</h2>
		<ValidationObserver v-slot="{ handleSubmit }">
			<b-form @submit.prevent="handleSubmit(addAnswer)">
				<div class="container mt-3">
					<b-row>
						<b-col sm="12" lg="2" class="fett text-right">Message</b-col>
						<b-col sm="12" lg="10">
							<validation-provider rules="required" v-slot="{ errors }">
								<b-form-textarea
									id="MSG_TEXT"
									v-model="answer"
									placeholder="Please answer here..."
									rows="4"
								>
								</b-form-textarea>
								<span class="formerror">{{ errors[0] }}</span>
							</validation-provider>
							<p />
							<b-button block type="submit" variant="primary">Send</b-button>
						</b-col>
					</b-row>
				</div>
			</b-form>
		</ValidationObserver>
	</div>
</template>
<style scoped lang="scss">
#editor {
	font-size: 18px;
	.row {
		border-top: 1px solid #ccc;
		padding: 20px 0;
	}
}
.fett {
	font-weight: bold;
}
.msg {
	white-space: pre-wrap;
}
</style>

<script>
import Spinner from "vue-simple-spinner";
import AttachmentDetail from "@/components/pages/AttachmentDetail";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { mapState } from "vuex";

export default {
	components: {
		ValidationProvider,
		ValidationObserver,
		AttachmentDetail,
		Spinner,
	},
	props: ["ticket", "statusse", "working", "changeStatus"],

	computed: mapState({
		// arrow functions can make the code very succinct!
		userdata: (state) => state.auth.userdata,
	}),

	data() {
		return {
			imgurl: "",
			renewclass: "",
			answer: "",
		};
	},
	created: function() {},
	methods: {
		showBig(id) {
			console.log("clicked id ", id);
			this.imgurl = this.ticket.messages[0].MSG_ATTACHMENTS[id].large;
			this.$bvModal.show("Attachmentdetail");
		},
		transmitForm() {
			this.addAnswer();
		},
		addAnswer() {
			let that = this;
			this.senddata = {
				MSG_TICKETID: that.ticket.TI_ID,
				MSG_FROMMAIL: that.userdata.user_email,
				MSG_USERID: that.userdata.user_id,
				MSG_TEXT: that.answer,
			};
			var headers = {
				headers: {
					Authorization: "Bearer " + localStorage.getItem("shareXToken"),
				},
			};

			that.$http
				.post("/tickets/answer", this.senddata, headers)
				.then(function(response) {
					that.changeStatus("answered", that.ticket.TI_ID);
					that.$toastr.Add({
						title: "Answer sent", // Toast Title
						msg: "",
						position: "toast-top-center",
						type: "success",
					});
					that.$emit("closeEditor");
				});
		},
	},
};
</script>
